import React, {useState} from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardActionArea } from '@mui/material';
import {ResponsiveContainer} from "recharts";


function PieChartCard(props) {
    const { title, pieChartContent, bottomContent, height } = props;
    
    let bottom = bottomContent === null ?
        null
        : <div>
            <br />
            {bottomContent}
        </div>;

    return (
        <Card elevation={4} className="height-100p">
            <CardActionArea className="height-100p">
                <CardContent className="pad-10-0">

                    <h6 className="pad-left-15">{title}</h6>
                    <ResponsiveContainer height={height}>
                        {pieChartContent}
                    </ResponsiveContainer>
                    {bottom}
                </CardContent>
            </CardActionArea>
        </Card>
    );
}

export default PieChartCard;